import { render, staticRenderFns } from "./GroupSessionParticipantNotesAddEditModal.vue?vue&type=template&id=7f038254&"
import script from "./GroupSessionParticipantNotesAddEditModal.vue?vue&type=script&lang=js&"
export * from "./GroupSessionParticipantNotesAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports